import { combineReducers } from 'redux'
import {
  createRequestReducer,
  createReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeWorks = data => {
  const work = new schema.Entity('works')
  return normalize(data, [work])
}

const WorksReducer = combineReducers({
  fetchWorksRequest: createRequestReducer('WORKS_STORE:FETCH', {
    pending: true
  }),
  assessmentFile: createReducer(null, {
    'WORKS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) => ({
      id: response.data.assessment_file.id,
      title: response.data.assessment_file.title,
      student_types: response.data.assessment_file.student_types,
      policy: response.data.assessment_file.policy
    })
  }),
  works: createReducer(null, {
    'WORKS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeWorks(response.data.assessment_file.works),
    'WORKS_STORE:ADD_WORKS_REQUEST_SUCCESS': (state, { response }) =>
      normalizeWorks(response.data.assessment_file.works),
    'WORKS_STORE:REMOVE_WORK_REQUEST_SUCCESS': (state, { params }) => {
      const works = { ...state.entities.works }
      delete works[params.workId]
      return {
        entities: { works },
        result: state.result.filter(id => id !== params.workId)
      }
    }
  }),
  selectedWorkId: createReducer(null, {
    'WORKS_STORE:SELECT_WORK_SUCCESS': (state, { workId }) => workId
  }),
  mediaKey: createReducer(0, {
    'WORKS_STORE:SET_MEDIA_SUCCESS': (state, { page }) => page
  }),
  addWorksDialog: createReducer(
    { opened: false },
    {
      'WORKS_STORE:ADD_WORKS_DIALOG:OPEN': (state, { params }) => ({
        ...state,
        opened: true,
        assessmentFileId: params.assessmentFileId,
        workIds: params.workIds,
        studentId: params.studentId
      }),
      'WORKS_STORE:ADD_WORKS_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  )
})

export default WorksReducer
